/** @deprecated please use fazzBizzThemeFds3 colors theme instead */
export enum WHITE {
  DEFAULT = '#FFFFFF',
}
